import type { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'
import { moderationApi } from '../moderationApi'

const endpoint = moderationApi.endpoints.getCourseModeration

/** Минимальное состояние, из которого читается кеш `/moderation`. */
export type ModerationSelectState = Parameters<ReturnType<typeof endpoint.select>>[0]

/**
 * Перечитать `/moderation` ПОСЛЕ записи. `forceRefetch` не пробивает летящий запрос того
 * же ключа (RTK склеивает), а тот мог уйти до записи и ответить без черновика — тогда
 * после него посылается ещё один. Промис — последнего запроса: ждущий получает свежее
 * состояние. Подписки не заводит: опрос ведёт `ModerationPoller`.
 */
export const refetchCourseModeration = (
  dispatch: ThunkDispatch<ModerationSelectState, unknown, UnknownAction>,
  getState: () => ModerationSelectState,
  courseId: number,
): Promise<unknown> => {
  const inFlight = endpoint.select(courseId)(getState()).isLoading
  const fetchFresh = () =>
    dispatch(endpoint.initiate(courseId, { forceRefetch: true, subscribe: false }))
  const req: Promise<unknown> = Promise.resolve(fetchFresh())
  return inFlight ? req.then(() => fetchFresh()) : req
}
